import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Hide24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M20.7975 8.16403C21.1488 8.38356 21.2555 8.84628 21.036 9.19753C20.5303 10.0066 19.9341 10.7468 19.259 11.3984L20.5916 12.7309C20.8845 13.0238 20.8845 13.4987 20.5916 13.7916C20.2987 14.0845 19.8238 14.0845 19.5309 13.7916L18.1065 12.3672C17.2022 13.0257 16.1944 13.5422 15.103 13.8827L15.6045 15.7545C15.7117 16.1546 15.4742 16.5659 15.0741 16.6731C14.674 16.7803 14.2628 16.5428 14.1556 16.1427L13.6413 14.2232C13.1093 14.3066 12.5615 14.35 12 14.35C11.4385 14.35 10.8907 14.3066 10.3587 14.2232L9.84447 16.1427C9.73728 16.5428 9.32603 16.7803 8.92593 16.6731C8.52583 16.5659 8.28837 16.1546 8.39556 15.7545L8.89704 13.8827C7.80565 13.5422 6.79775 13.0257 5.89349 12.3672L4.46909 13.7916C4.1762 14.0845 3.70132 14.0845 3.40843 13.7916C3.11554 13.4987 3.11554 13.0238 3.40843 12.7309L4.741 11.3983C4.06595 10.7468 3.46969 10.0066 2.96402 9.19753C2.74448 8.84628 2.85126 8.38356 3.20251 8.16403C3.55377 7.9445 4.01648 8.05128 4.23601 8.40253C4.80245 9.30882 5.49326 10.1097 6.28719 10.7732C6.30236 10.7848 6.31719 10.7971 6.33164 10.8101C7.88429 12.0914 9.82603 12.85 12 12.85C15.3118 12.85 18.0846 11.0896 19.764 8.40253C19.9836 8.05127 20.4463 7.9445 20.7975 8.16403Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
